<template>
 <div>
   <div class="p-fluid p-formgrid p-grid">
     <div class="p-field p-col-12 p-md-9"></div>
     <div class="p-field p-col-12 p-md-1">
      <Button class="p-button-raised btn" @click="generateReport" label="Print"
      icon="pi pi-print"/>
     </div>
    <div class="p-field p-col-12 p-md-1">
      <Button class="p-button-raised p-button-danger btn" @click.prevent="$router.back()" label="Cancel"/>
    </div>
  </div>
    <Card v-if="printType === 'bill' || printType === 'qot'" >
      <template #content>
        <div class="p-grid">
          <div class="p-col-4"></div>
          <div class="p-col-4">
            <img :src="$store.state.organisationLogo" style="text-align:center" alt="Logo"
            class="img-responsive center-block logo">
          </div>
          <div class="p-col-4"></div>
      </div>
     <div class="p-grid">
       <div class="p-col-1"></div>
       <div class="p-col-10">
         <h5 style="text-align:-webkit-center;font-size:18px">{{organisationName}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">{{organisationAddress}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">{{organisationContact}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">Pan No: {{organisationPanNo}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">Cash Receipt</h5>
       </div>
       <div class="p-col-1"></div>
     </div>
     <div class="p-grid">
       <div class="p-col-6">
        <span>Name:{{customerName}}</span><br/>
        <span>Contact:{{customerNumber}}</span>
       </div>
       <!-- <div class="p-col-6 p-ml-1">
       </div> -->
       <div class="p-col-6" style="margin-left: -4%;">
         <span for="fromDate" style="float:right">Date: {{nepaliDate}}</span><br/>
         <span for="fromDate" style="float:right">Bill No: {{billNo}}</span>
       </div>
       <!-- <div class="p-col-6 p-ml-1">
       </div> -->
     </div>
     <table class="table table-bordered"  style="max-width: 96%;">
       <thead style="padding: 4px; font-size: 10px;">
         <tr>
           <th style="text-align:center;">S.n</th>
           <th style="text-align:center;">Particular</th>
           <th style="text-align:center">Qty</th>
           <th style="text-align:center">Rate</th>
           <th style="text-align:center" >Amount</th>
        </tr>
       </thead>
       <tbody v-for="(item,index) in salesList " :key="index">
         <tr>
           <td>{{index+1}}</td>
           <td>{{item.itemName}}</td>
           <td style="text-align:right">{{item.quantity}}</td>
           <td style="text-align:right">{{item.sellingPrice}} </td>
           <td style="text-align:right">{{item.sellingPrice * item.quantity}} </td>
         </tr>
       </tbody>
       <tfoot>
         <tr>
           <td></td>
           <td colspan="1" style="text-align:center">Total:</td>
           <td style="text-align:right">{{totalQty}}</td>
            <td></td>
           <td style="text-align:right">{{totalSubTotal}}</td>
         </tr>
       </tfoot>
     </table>
     <div class="p-grid p-col-12">
       <div class="p-col-12">
         <span for="fromDate">Gross Amount: {{subTotalAmount}}</span>
        </div>
        <div class="p-col-12">
          <span for="fromDate">Discount Amount: {{discountAmt}}</span>
        </div>
        <div class="p-col-12" v-if="this.taxType==='Vat'">
          <span for="fromDate">Vatable Amount: {{vatAmount}}</span>
        </div>
        <div class="p-col-12" v-if="this.taxType==='Vat'">
          <span for="fromDate">Vat 13%: {{vatPercentage}}</span>
        </div>
        <div class="p-col-12">
          <span for="fromDate">Total Amount: {{billAmount}}</span>
        </div>
        <div class="p-col-12">
          <span for="fromDate">Tender Amount: {{tenderAmount}}</span>
        </div>
        <div class="p-col-12">
          <span>Amount In Words: {{amountInWords}}</span>
        </div>

     </div>
     <div class="p-col-12">
       <span style="float:right;margin-right: 38px">Received By: {{receivedBy}}</span>
     </div>
     <div class="p-grid p-col-12">
       <div class="p-col-12 p-offset-3">
         <span style="font-size:10px;">Powered By Raise Tech Pvt.Ltd.</span>
       </div>
     </div>


     </template>
  </Card>
  <br/>

  <Card v-if="printType === 'qot'">
      <template #content>
        <div class="p-grid">
          <div class="p-col-4"></div>
          <div class="p-col-4">
            <img :src="$store.state.organisationLogo" style="text-align:center" alt="Logo"
            class="img-responsive center-block logo">
          </div>
          <div class="p-col-4"></div>
      </div>
     <div class="p-grid">
       <div class="p-col-1"></div>
       <div class="p-col-10">
         <h5 style="text-align:-webkit-center;font-size:18px">{{organisationName}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">{{organisationAddress}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">{{organisationContact}}</h5>
         <!-- <h5 style="text-align:-webkit-center;margin-top: -8px;">Pan No: {{organisationPanNo}}</h5> -->
         <h5 style="text-align:-webkit-center;margin-top: -8px;">KOT</h5>
       </div>
       <div class="p-col-1"></div>
     </div>
     <div class="p-grid">
       <div class="p-col-6">
        <span>Name:{{customerName}}</span><br/>
        <span>Contact:{{customerNumber}}</span>
       </div>
       <!-- <div class="p-col-6 p-ml-1">
       </div> -->
       <div class="p-col-6" style="margin-left: -4%;">
         <span for="fromDate" style="float:right">Date: {{nepaliDate}}</span><br/>
         <span for="fromDate" style="float:right">Bill No: {{billNo}}</span>
       </div>
       <!-- <div class="p-col-6 p-ml-1">
       </div> -->
     </div>
     <table class="table table-bordered" >
       <thead style="padding: 4px; font-size: 10px;">
         <tr>
           <th style="text-align:center;">S.n</th>
           <th style="text-align:center;">Particular</th>
           <th style="text-align:center">Qty</th>
        </tr>
       </thead>
       <tbody v-for="(item,index) in salesList " :key="index">
         <tr>
           <td>{{index+1}}</td>
           <td>{{item.itemName}}</td>
           <td style="text-align:right">{{item.quantity}}</td>
         </tr>
       </tbody>
     </table>
     <div class="p-col-12">
       <span style="float:right">Received By: {{receivedBy}}</span>
     </div>
     </template>
  </Card>

  <Card v-if="printType === 'qott'">
      <template #content>
        <div class="p-grid">
          <div class="p-col-4"></div>
          <div class="p-col-4">
            <img :src="$store.state.organisationLogo" style="text-align:center" alt="Logo"
            class="img-responsive center-block logo">
          </div>
          <div class="p-col-4"></div>
      </div>
     <div class="p-grid">
       <div class="p-col-1"></div>
       <div class="p-col-10">
         <h5 style="text-align:-webkit-center;font-size:18px">{{organisationName}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">{{organisationAddress}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">{{organisationContact}}</h5>
         <!-- <h5 style="text-align:-webkit-center;margin-top: -8px;">Pan No: {{organisationPanNo}}</h5> -->
         <h5 style="text-align:-webkit-center;margin-top: -8px;">KOT</h5>
       </div>
       <div class="p-col-1"></div>
     </div>
     <div class="p-grid">
       <div class="p-col-6">
        <span>Name:{{customerName}}</span><br/>
        <span>Contact:{{customerNumber}}</span>
       </div>
       <!-- <div class="p-col-6 p-ml-1">
       </div> -->
       <div class="p-col-6" style="margin-left: -4%;">
         <span for="fromDate" style="float:right">Date: {{nepaliDate}}</span><br/>
         <span for="fromDate" style="float:right">Bill No: {{billNo}}</span>
       </div>
       <!-- <div class="p-col-6 p-ml-1">
       </div> -->
     </div>
     <table class="table table-bordered" >
       <thead style="padding: 4px; font-size: 10px;">
         <tr>
           <th style="text-align:center;">S.n</th>
           <th style="text-align:center;">Particular</th>
           <th style="text-align:center">Qty</th>
        </tr>
       </thead>
       <tbody v-for="(item,index) in salesList " :key="index">
         <tr>
           <td>{{index+1}}</td>
           <td>{{item.itemName}}</td>
           <td style="text-align:right">{{item.quantity}}</td>
         </tr>
       </tbody>
     </table>
     <div class="p-col-12">
       <span style="float:right">Received By: {{receivedBy}}</span>
     </div>
     </template>
  </Card>

</div>
</template>
<script>
import Button from 'primevue/button'
import Card from 'primevue/card'
export default {
  name: 'posPrintPage',
  props: ['printData'],
  data() {
    return {
      organisationName: '',
      organisationAddress: '',
      organisationContact: '',
      organisationPanNo: '',
      customerName: '',
      customerNumber: '',
      billNo: '',
      // englishDate: null,
      nepaliDate: null,
      salesList: [],
      narration: '',
      subTotalAmount: 0.0,
      discountAmt: 0.0,
      vatPercentage: 0.0,
      vatAmount: 0.0,
      billAmount: 0.0,
      tenderAmount: 0.0,
      returnedAmount: 0.0,
      amountInWords: '',
      totalQty: 0,
      totalSubTotal: 0,
      receivedBy: '',
      printType: '',
      taxType: ''
    }
  },
  mounted () {
    this.openVoucherDialog()
  },
  computed: {
  },
  methods: {
    async openVoucherDialog() {
      if (this.printData === undefined) {
        this.$router.back()
        return
      }
      this.organisationName = this.$store.state.organisationName
      this.organisationAddress = this.$store.state.organisationAddress
      this.organisationContact = this.$store.state.organisationContact
      this.organisationPanNo = this.$store.state.organisationPanVatNo
      this.organisationLogo = this.$store.state.organisationLogo
      this.receivedBy = this.$store.state.user.name
      this.taxType = this.$store.state.taxType
      // // debugger
      this.salesList = this.printData.childSalesDetailsDTOList
      this.nepaliDate = this.printData.salesDateNepali
      this.customerName = this.printData.customerName
      this.customerNumber = this.printData.contactNumber
      this.tenderAmount = this.printData.tenderAmount
      this.returnedAmount = this.printData.returningAmount
      this.billAmount = this.printData.billAmount
      this.vatPercentage = this.printData.vatPercentage
      this.vatAmount = this.printData.vatAmount
      this.discountAmt = this.printData.discountAmount
      this.amountInWords = this.printData.amountInWords
      this.billNo = this.printData.billPrefix
      this.subTotalAmount = this.printData.subTotalAmount
      this.printType = this.printData.printTyp
      this.findTotalQty()
    },
    findTotalQty() {
      this.totalQty = 0
      for (let i = 0; i < this.salesList.length; i++) {
        this.totalQty += this.salesList[i].quantity
        this.totalSubTotal += parseFloat(this.salesList[i].quantity) * parseFloat(this.salesList[i].sellingPrice)
      }
    },
    generateReport () {
      window.print()
    }
  },
  components: {
    Button,
    Card
  }
}
</script>
<style scoped >
@media print {
    .btn {
      display: none !important;
    }
}
</style>



// WEBPACK FOOTER //
// posPrintPage.vue?688ea852